<template>
  <div>
    <template v-if="!isLoading">
      <LmListV2 ref="LmListV2"
        :isGraphql="true"
        :gqlField="gqlField"
        :gqlVariables="gqlVariables"
        :gqlQuery="gqlQuery"
        :searchOnFieldsSelected="searchOnFieldsSelected"
        :searchOnFieldsToSelected="searchOnFieldsToSelected"
        :items="items"
        :allAvailableFields="allAvailableFields"
        :mode="mode"
        :listBuilderTitleList="listBuilderTitleList"
        :listBuilderAlias="listBuilderAlias"
        :listBuilderButtons="listBuilderButtons"
        :modeBoxOptions="modeBoxOptions"
        :selectable="selectable"
        @ready="isLoading = false"
      />
    </template>
    <LmLoading v-else />
  </div>
</template>

<script>
import commonsApi from '@/api/commons'
import LmListV2 from '@/components/LmListV2'

export default {
  data () {
    return {
      gqlField: '',
      gqlQuery: '',
      gqlVariables: '',
      searchOnFieldsSelected: '',
      searchOnFieldsToSelected: '',
      allAvailableFields: [],
      form: { newFields: {} },
      mode: {
        table: true,
        map: false,
        box: false
      },
      modeBoxOptions: {},
      listBuilderTitleList: '',
      listBuilderAlias: '',
      listBuilderButtons: [],
      selectable: false,
      listbuilderComponentReady: false,
      isLoading: false
    }
  },
  components: {
    LmListV2
  },
  methods: {
    async getListValues () {
      try {
        this.isLoading = true
        const endPoint = await commonsApi.axiosGetWrapper(`listbuilder/${this.$route.params.id}`, { p: 'list' })
        this.gqlField = endPoint.data.gqlField
        this.gqlQuery = endPoint.data.gqlQuery
        this.gqlVariables = endPoint.data.gqlVariables
        this.searchOnFieldsSelected = endPoint.data.searchOnFieldsSelected
        this.searchOnFieldsToSelected = endPoint.data.searchOnFieldsToSelected
        this.items = endPoint.data.items
        this.allAvailableFields = endPoint.data.fields
        this.mode = endPoint.data.mode
        this.listBuilderTitleList = endPoint.data.titleList
        // Por https://github.com/lumile/lumbre/issues/1185 se decide mostrar el alias
        // de un listado para aquellos creados por los usuarios.
        // Los listados lumbreInternal:true se usa como titulo el esquema anterior de
        // titleList
        this.listBuilderAlias = endPoint.data?.lumbreInternal ? null : endPoint.data?.alias
        this.listBuilderButtons = endPoint.data.buttonLinks
        this.modeBoxOptions = endPoint.data.modeBoxOptions
        this.selectable = endPoint.data?.selectable || false
        this.listbuilderComponentReady = true
      } catch (error) {
        console.log(error)
        this.$router.push('/')
      } finally {
        this.isLoading = false
      }
    }
  },
  watch: {
    async '$route.params.id' () {
      await this.getListValues()
    }
  },
  async created () {
    await this.getListValues()
  }
}
</script>
